/**
 * Default requirements import
 */

import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './rootReducer';
import { citiesStore } from './redux/cities/model';
import { applicationStore } from './redux/application/model';

import sharedComponentsEpic from './screens/shared/epics';

const loggerMiddleWare = () => next => action => {
    console.log('[LOG] Action triggered', action);
    next(action);
};

export const history = createBrowserHistory();

const rootEpic = combineEpics(sharedComponentsEpic),
    epicMiddleware = createEpicMiddleware(rootEpic);

/**
 * Initialize store.
 * @type {{auth: {isAuthenticated: boolean, authLoading: boolean, authErrored: boolean, errorMessage: string}}}
 */
const initialState = {
        register: {
            license: {},
            identity: {},
            personalDetails: {},
        },
        filterEvents: {
            by: '',
            query: {
                value: '',
                label: '',
            },
        },
        cities: citiesStore,
        application: applicationStore,
    },
    enhancers = [],
    middleware = [thunk, epicMiddleware, routerMiddleware(history), loggerMiddleWare];

if (process.env.NODE_ENFV === 'development') {
    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = composeWithDevTools(applyMiddleware(...middleware), ...enhancers);

const saveSubsetBlacklistFilter = createBlacklistFilter();

const config = {
    key: 'vulogv2',
    storage,
    transforms: [
        saveSubsetBlacklistFilter,
        createBlacklistFilter('filterEvents', ['query', 'by']),
        createBlacklistFilter('form', []),
        createBlacklistFilter('application', ['isMediaDevicesEnabled', 'modalOpeningCount']),
    ],
};

const reducer = persistCombineReducers(config, rootReducer);
function configureStore() {
    let store = createStore(reducer, initialState, composedEnhancers);
    let persistor = persistStore(store);
    return { persistor, store };
}

export default configureStore;
